<script setup>
import { useRoute } from 'vue-router';
const route = useRoute();
</script>

<template>
  <div
    class="overflow-auto bg-n-surface-1 w-full min-w-0"
    :class="route.name === 'zuwad_ai_reviews' ? 'px-0' : 'px-6'"
  >
    <div
      class="mx-auto min-w-0"
      :class="
        route.name === 'zuwad_ai_reviews'
          ? 'w-full pb-24 xl:pb-0'
          : 'max-w-5xl pb-12'
      "
    >
      <router-view />
    </div>
  </div>
</template>
